import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ShoppingCart, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { ContactStep, useContact } from "@/components/AddressBook";
import { api, errMsg } from "@/lib/api";

export function RxOrderButton({ rx }) {
  const [open, setOpen] = useState(false);
  const [list, setList] = useState(null);
  const [pid, setPid] = useState("");
  const [c, setC] = useContact();
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  useEffect(() => {
    if (!open) return;
    const load = (params) => api.get("/market/pharmacies", { params }).then((r) => { setList(r.data); setPid((x) => x || r.data[0]?.id || ""); });
    navigator.geolocation ? navigator.geolocation.getCurrentPosition((p) => load({ lat: p.coords.latitude, lng: p.coords.longitude }), () => load({})) : load({});
  }, [open]);
  const place = async () => {
    if (!c.address_id) return toast.error("Choose or add a delivery address");
    setBusy(true);
    try { await api.post("/market/rx-orders", { prescription_id: rx.id, partner_id: pid, ...c }); toast.success("Sent to pharmacy. They'll share the price – track it in Orders."); setOpen(false); nav("/patient/orders"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <Button size="sm" variant="outline" className="rounded-full" onClick={(e) => { e.preventDefault(); setOpen(true); }} data-testid={`rx-order-btn-${rx.id}`}><ShoppingCart className="h-3.5 w-3.5 mr-1" />Order medicines</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-xl max-h-[90vh] overflow-y-auto" data-testid="rx-order-dialog">
          <DialogHeader><DialogTitle>Order medicines for {rx.rx_number}</DialogTitle><DialogDescription>The nearest pharmacy is selected. It will confirm availability and price, then you pay.</DialogDescription></DialogHeader>
          <div className="space-y-2 max-h-48 overflow-auto">{list === null ? <p className="text-sm muted">Finding nearby pharmacies…</p> : list.length === 0 ? <p className="text-sm muted">No partner pharmacies available yet.</p> : list.map((p) => (
            <label key={p.id} className={`flex items-center justify-between gap-2 rounded-xl border p-3 cursor-pointer text-sm ${pid === p.id ? "border-[#086B2D] bg-[#086B2D]/5" : "border-[#E2E8ED]"}`} data-testid={`rx-pharmacy-${p.id}`}>
              <span><input type="radio" className="mr-2" checked={pid === p.id} onChange={() => setPid(p.id)} />{p.name} <span className="muted text-xs">{p.city}</span></span>
              {p.distance_km != null && <span className="text-xs muted flex items-center gap-1"><MapPin className="h-3 w-3" />{p.distance_km} km</span>}
            </label>))}</div>
          <ContactStep c={c} setC={setC} />
          <DialogFooter><Button className="rounded-full w-full" disabled={busy || !pid} onClick={place} data-testid="rx-order-submit">Send prescription to pharmacy</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
